(function () {
  'use strict';

  /**
   * Format cents as a money string using the shop's money format.
   * Falls back to a simple USD formatter if window.theme.moneyFormat is unavailable.
   */
  function formatMoney(cents) {
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimalsWithCommas = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return moneyFormat
      .replace('{{amount}}', withCommas)
      .replace('{{amount_no_decimals}}', noDecimalsWithCommas)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals);
  }

  function parseMap(str) {
    if (!str) return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  /**
   * On variant change, update the per-day price block(s) for the selected variant.
   *
   * The per-day block (data-perday-container) is intentionally NOT a
   * [data-unit-price-container], so the theme's own updateUnitPrices() — which
   * rewrites unit-price elements with the native Shopify unit price ("/item") —
   * never touches it. We own it entirely here. The variant→per-day(cents) map is
   * precomputed server-side and is always valid JSON, so a variant with no
   * servings simply isn't in the map and we hide the line for it.
   */
  function updatePerDay(variant) {
    var containers = document.querySelectorAll('[data-perday-container][data-perday-map]');
    containers.forEach(function (container) {
      var map = parseMap(container.getAttribute('data-perday-map'));
      if (!map) {
        container.dataset.unitPriceAvailable = 'false';
        return;
      }

      var entry = map[String(variant.id)];
      var amountEl = container.querySelector('[data-perday-amount]');
      var subLabelEl = container.querySelector('[data-perday-sublabel]');

      if (entry != null) {
        // entry is [perDayCents, isSubscription]; tolerate a bare number too.
        var cents = Array.isArray(entry) ? entry[0] : entry;
        var isSub = Array.isArray(entry) ? !!entry[1] : false;
        if (amountEl) amountEl.innerText = formatMoney(cents);
        if (subLabelEl) subLabelEl.hidden = !isSub;
        container.dataset.unitPriceAvailable = 'true';
      } else {
        container.dataset.unitPriceAvailable = 'false';
      }
    });
  }

  /**
   * Legacy day-supply containers (cart/native style) kept for safety in case any
   * non per-day unit-price snippet is on a page that fires variant-change.
   */
  function updateLegacyUnitPrice(variant) {
    var containers = document.querySelectorAll(
      '[data-unit-price-container][data-days-supply-map]'
    );
    containers.forEach(function (container) {
      var map = parseMap(container.getAttribute('data-days-supply-map'));
      if (!map) return;

      var daysSupply = map[String(variant.id)];
      if (daysSupply == null) {
        container.dataset.unitPriceAvailable = 'false';
        return;
      }

      container.dataset.unitPriceAvailable = 'true';

      var priceEl = container.querySelector('[data-unit-price]');
      if (priceEl) priceEl.innerText = formatMoney(variant.price);

      var baseEl = container.querySelector('[data-unit-price-base-unit]');
      if (baseEl) baseEl.innerText = daysSupply + ' day supply';
    });
  }

  function updateDaysSupplyBadges(variant) {
    var badges = document.querySelectorAll('[data-days-supply-badge][data-days-supply-badge-map]');
    badges.forEach(function (badge) {
      var map = parseMap(badge.getAttribute('data-days-supply-badge-map'));
      if (!map) return;
      var text = map[String(variant.id)];
      if (!text) return;
      var span = badge.querySelector('.product-blocks__product-labels-item-text');
      if (span) span.innerText = text;
    });
  }

  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    updatePerDay(variant);
    updateLegacyUnitPrice(variant);
    updateDaysSupplyBadges(variant);
  });
})();
